import { memo } from "react";

import WarningBoolIndicator from "components/StatusIndicators/WarningBoolIndicator";

const WarningBoolCellRenderer = ({ value, ...props }) => {
  return <WarningBoolIndicator value={value} type="icon" />;
};

export default memo(WarningBoolCellRenderer);
